import { render, staticRenderFns } from "./SubItemList.vue?vue&type=template&id=386b60c8&scoped=true&"
import script from "./SubItemList.vue?vue&type=script&lang=js&"
export * from "./SubItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b60c8",
  null
  
)

export default component.exports